import Turbolinks from 'turbolinks'
import vueComponent from './vue-component'

import {mapGetters} from 'vuex'
import {store} from '../store/index'
import './modules/turbolinks-reload'
import {createAppComponent} from '@tfx/common/initializers'

import dialogsMixins from './modules/dialogs-mixins'

import {initVueJs} from './init-vuejs'
import Plugin from './plugins'
import {Notifier} from './components/notifier'
import 'tfx-common/modules/trix-nonanscii'
import {bindToFormErrors} from './turbolinks-handler'

export class App {
  constructor(runTurbolinks = false) {
    this.runTurbolinks = runTurbolinks
    this.Plugin = Plugin
    this.notifier = new Notifier()
    this.checkMobileDownloads = false
    this.eventCallbacks = {}
  }

  activateTurbolinks() {
    this.runTurbolinks = true
  }

  notify(title, opts = {}) {
    if (!title && opts.type === 'error') {
      title = 'An unexpected error has occurred.'
    }
    return this.notifier.notify(title, opts)
  }

  removeAllNotices() {
    return this.notifier.removeAll()
  }

  bindings() {
    if (this.runTurbolinks) {
      document.addEventListener('turbolinks:load', (_ev) => {
        store.dispatch('dialogs/resetDialogs')
        this.Plugin.loader.domLoaded = true
        this._initVue()
        if (this.initializer) {
          this.initializer.initialize()
        }
        this._simpleResponseBindings()
      })
      window.onpopstate = (ev) => {
        Turbolinks.clearCache()
      }
      document.addEventListener('turbolinks:before-cache', (_ev) => {
        if (this.initializer) {
          this.initializer.destroyInitialized()
        }
        this.tfxComponents.forEach((comp) => comp.unmount())
        if (this.modalContainerApp) {
          this.modalContainerApp.unmount()
          delete this.modalContainerApp
        }
        this.Plugin.loader.domLoaded = false
      })
    } else {
      this._initVue()
      if (this.initializer) {
        this.initializer.initialize()
      }
    }
    if (this.checkMobileDownloads) {
      this._bindToDownloadLinks()
    }
  }

  start() {
    this.bindings()
    if (this.runTurbolinks) {
      Turbolinks.start()
    }
    store.dispatch('geoLocation/getGeoData')
    store.dispatch('authorization/getClientData')
  }

  onEvent(eventName, callback) {
    this.eventCallbacks[eventName] ||= []
    this.eventCallbacks[eventName].push(callback)
  }

  removeEventListener(eventName, callback) {
    if (!this.eventCallbacks[eventName]) return

    const index = this.eventCallbacks[eventName].indexOf(callback)
    if (index > -1) {
      this.eventCallbacks[eventName].splice(index, 1)
    }
  }

  triggerEvent(event, payload = {}) {
    if (this.eventCallbacks[event]) {
      this.eventCallbacks[event].forEach((f) => f(event, payload))
    }
  }

  _initVue() {
    initVueJs()
    this.tfxComponents = []
    vueComponent.perform(this.tfxComponents)
    if (document.getElementById('modalcontainer')) {
      this.modalContainerApp = createAppComponent({
        name: 'modal-dialog-container',
        store,
        mixins: [dialogsMixins],
        computed: {
          ...mapGetters('dialogs', {
            showModalDialog: 'showModalDialog',
            modalDialogs: 'modalDialogs',
            isAllErbModalsClosed: 'isAllErbModalsClosed'
          })
        }
      })

      this.modalContainerApp.mount('#modalcontainer')
    }
    const activeClientDiv = document.getElementById('active-client-id-div')
    if (activeClientDiv) {
      store.dispatch('admin/sidebar/updateActiveClient', activeClientDiv.dataset.activeClientId)
    }
  }

  _simpleResponseBindings() {
    Array.from(document.querySelectorAll('form.simple-response')).forEach((el) => {
      el.addEventListener('ajax:success', function (event) {
        let notice = 'Update successfully'
        if (event && event.detail && event.detail[0] && event.detail[0].notice) {
          notice = event.detail[0].notice
        }
        app.notify(notice, {type: 'success'})
      })
      el.addEventListener('ajax:error', function () {
        app.notify('Update error', {type: 'error'})
      })
    })

    bindToFormErrors()
  }

  _bindToDownloadLinks() {
    // template method, should be implemented in client/app.js
  }
}

export const app = new App()
window.app = app
window.$store = store
